import { toWords } from "number-to-words";
export const extractValueFromInputRef = (ref)=> ref.current.input.value;

export const refreshPage = ()=> window.location.reload();

export const Default = {
    token: null
}

export const scrollToTop = ()=>{
    window.scrollTo({
        top:0,
        behavior:"smooth"
    })
}

export const numberToWords = (figure)=>toWords(figure);